$(function() {
  $(".accordion-box").click(function() {
      var $this = $(this);
      var $detail = $this.find(".accordion-job-detail");
      $detail.stop(true, true).slideToggle(400);
      $this.toggleClass("active");
  });
});